import Joi from "joi";
import Form from "../../common/form";
import PropTypes from "prop-types";
import toast from "react-hot-toast";

import { PDFImageProps } from "../../../utils/models";
import { IMAGE_LIMITS } from "../../../utils/constants";
import { getFileUploadTypes } from "../../../utils/utilities";

import Button from "../../themed/button";
import Conditional from "../../common/conditional";

interface InfraredResult {
    imagingLocation: string;
    elevation: string;
    suspectedSedimentLevel: number;
    calculatedDepositVolume: number;
    maxTemperature: number;
    minTemperature: number;
    scanImage: PDFImageProps[]; 
}

class InfraredResultForm extends Form {
    state = { 
        data: {
			imagingLocation: '',
            elevation: '',
            suspectedSedimentLevel: '',
            calculatedDepositVolume: '',
            maxTemperature: '',
            minTemperature: '',
            scanImage: [], 
		},
		errors: {},
		loading: false,
		progress: 0
    };

    schema = {
        imagingLocation: Joi.string().required().label('Imaging Location'),
        elevation: Joi.number().required().label('Elevation'),
        suspectedSedimentLevel: Joi.number().required().label('Suspected Sediment Level (Cm)'),
        calculatedDepositVolume: Joi.number().required().label('Calculated Volume of Sediment Deposit'),
        maxTemperature: Joi.number().required().label('Max Temperature'),
        minTemperature: Joi.number().required().label('Min Temperature'),
        scanImage: Joi.array().min(1).max(IMAGE_LIMITS.SCAN_IMAGE).required().label('Scan Image'),
    };

    static propTypes = {
        initialResultData: PropTypes.object,
        onDeleteItem: PropTypes.func,
        onSave: PropTypes.func,
    };

    componentDidMount(): void {
        if (this.props.initialResultData) {
            this.setState({ data: this.props.initialResultData });
        }
    }

    doSubmit = () => {
        this.props.onSave(this.state.data);

        if (!this.props.initialResultData) {
            this.setState({
                data: {
                    imagingLocation: '',
                    elevation: '',
                    suspectedSedimentLevel: '',
                    calculatedDepositVolume: '',
                    maxTemperature: '',
                    minTemperature: '',
                    scanImage: [],
                },
            })
        }

        toast.success('Saved successfully!');
    };

    render() { 
        return ( 
            <form autoComplete="off" onSubmit={this.handleSubmit}>
				<h3 className="form-title">Results</h3>

                <div className="container">
                    <div className="row">
                        <div className="col">
                            {this.renderInput({
                                type: 'text',
                                name: 'imagingLocation',
                                label: 'Imaging Location',
                                placeholder: 'Enter Imaging Location',
                            })}
                        </div>

                        <div className="col">
                            {this.renderInput({
                                type: 'number',
                                name: 'elevation',
                                label: 'Elevation',
                                placeholder: 'Enter Elevation',
                            })}
                        </div>

                        <div className="col">
                            {this.renderInput({
                                type: 'number',
                                name: 'suspectedSedimentLevel',
                                label: 'Suspected Sediment Level (Cm)',
                                placeholder: 'Enter Suspected Sediment Level (Cm)',
                            })}
                        </div>
                        
                        <div className="col">
                            {this.renderInput({
                                type: 'number',
                                name: 'calculatedDepositVolume',
                                label: 'Calculated Volume of Sediment Deposit (m3)',
                                placeholder: 'Enter Calculated Volume of Sediment Deposit (m3)',
                            })}
                        </div>
                    </div>
                    
                    <div className="divider my-4"></div>

                    <div className="row">
                        <div className="col">
                            {this.renderInput({
                                type: 'number',
                                name: 'maxTemperature',
                                label: 'Max Temperature (C)',
                                placeholder: 'Enter Max Temperature (C)',
                            })}
                        </div>
                        
                        <div className="col">
                            {this.renderInput({
                                type: 'number',
                                name: 'minTemperature',
                                label: 'Min Temperature (C)',
                                placeholder: 'Enter Min Temperature (C)',
                            })}
                        </div>

                        <div className="col">
                           {this.renderFileInput({
                                max: IMAGE_LIMITS.SCAN_IMAGE,
                                hideCaption: true,
                                multiple: IMAGE_LIMITS.SCAN_IMAGE > 1,
                                name: 'scanImage',
                                accept: 'image/*,application/pdf',
                                label: 'Scan',
                                sublabel: 'Upload Scan Image',
                                types: getFileUploadTypes(),
                            })}
                        </div>
                    </div>
                </div>

                <div className="divider my-4"></div>

                <div className="d-flex justify-content-end">
                    <Conditional isVisible={!!this.props.onDeleteItem}>
                        <div className="me-3">
                            <Button
                                onClick={this.props.onDeleteItem} 
                                icon="trash"
                                type="button"
                                label="Delete" 
                                style={{ backgroundColor: 'red' }} 
                            />
                        </div>
                    </Conditional>

				    {this.renderButton('Save')}
                </div>
			</form>
        );
    }
}

export type { InfraredResult };
export default InfraredResultForm;